@if (loading) {
    <div class="h-100 w-100 d-flex align-items-center justify-content-center" [ngClass]="{'loader-background-color': context === PaymentContext.PaymentPortal}">
        <div class="text-center">
            <div [attr.data-sb-qa]="'$$PaymentPage_Loading_Spinner'" class="spinner-border" [ngClass]="{'base-0': context === PaymentContext.PaymentPortal, 'base-100': context !== PaymentContext.PaymentPortal}"></div>
        </div>
    </div>
} @else if (!Scope.schoolInfo.Active || invoiceStatus !== InvoiceStatus.Open || !Scope.paymentProcessor) {
    <div class="w-100">
        <lib-card qaTag="$$PaymentPage_Card_PaymentStatus">
            <div>
                <ng-container *ngTemplateOutlet="schoolInformation"></ng-container>
                <hr>
                @if (invoiceStatus === InvoiceStatus.Paid) {
                    <h5 i18n="@@CommonPaymentPagePaymentCompletedLabel">Payment Completed</h5>
                    <p class="pt-3" i18n="@@CommonPaymentPageInvoicePaid">This invoice has already been paid. Thank you!</p>
                    <div class="d-flex justify-content-center w-100 py-3">
                        <lib-svg src="assets/images/InvoicePaid.svg" [height]="215"></lib-svg>
                    </div>
                } @else if (!Scope.schoolInfo.Active) {
                    <h5 i18n="@@CommonPaymentPageSchoolNotActiveLabel">#Studio# is No Longer Active</h5>
                    <p class="pt-3" data-clarity-mask="true" i18n="@@CommonPaymentPageSchoolNotActiveDescription">{{Scope.schoolInfo.Name}} is no longer active.</p>
                    <div class="d-flex justify-content-center w-100 py-3">
                        <lib-svg src="assets/images/NoOnlinePayments.svg" [height]="215"></lib-svg>
                    </div>
                } @else if (invoiceStatus === InvoiceStatus.Void) {
                    <h5 i18n="@@CommonPaymentPageInvoiceVoidLabel">Invoice is Void</h5>
                    <p class="pt-3" data-clarity-mask="true" i18n="@@CommonPaymentPageInvoiceVoidDescription">This invoice was marked as void. Please contact {{Scope.schoolInfo.Name}} for an updated invoice.</p>
                    <div class="d-flex justify-content-center w-100 py-3">
                        <lib-svg src="assets/images/InvoiceVoid.svg" [height]="215"></lib-svg>
                    </div>
                } @else {
                    <h5 i18n="@@CommonPaymentPageNoOnlinePaymentsLabel">No Online Payments</h5>
                    <p class="pt-3" data-clarity-mask="true" i18n="@@CommonPaymentPageNoOnlinePaymentsDescription">{{Scope.schoolInfo.Name}} is not set up to take online payments.</p>
                    <div class="d-flex justify-content-center w-100 py-3">
                        <lib-svg src="assets/images/NoOnlinePayments.svg" [height]="215"></lib-svg>
                    </div>
                }
            </div>
        </lib-card>
    </div>
} @else {
    <div [@slideInOut]="currentStep">
        @if (currentStep === 0) {
            <div class="d-flex gap-3" [ngClass]="{'flex-column': isMobileOrTablet}">
                <div class="d-flex flex-column" [ngClass]="{'w-75': !isMobileOrTablet, 'w-100': isMobileOrTablet}">
                    @if (context === PaymentContext.PaymentPortal || Scope.schoolInfo.AllowPartialPayments || hasZeroAmountDue) {
                        <div class="mb-3">
                            <lib-card qaTag="$$PaymentPage_Card_Amount">
                                <div>
                                    @if (context === PaymentContext.PaymentPortal) {
                                        <ng-container *ngTemplateOutlet="schoolInformation"></ng-container>
                                    }
                                    @if (Scope.schoolInfo.AllowPartialPayments || hasZeroAmountDue) {
                                        <form [formGroup]="form">
                                            <lib-input-currency
                                                [formControl]="form.controls.Amount"
                                                [debounceTime]="300"
                                                (realTimeValueChanged)="AmountChanged($event)"
                                                [qaTag]="'input-amount'">
                                                <ng-container supportingText>
                                                    {{ hasZeroAmountDue | method: GetHintMessageForAmount }}
                                                </ng-container>
                                                <ng-container label i18n="@@CommonAmountLabel">
                                                    Amount
                                                </ng-container>
                                            </lib-input-currency>
                                        </form>
                                    }
                                </div>
                            </lib-card>
                        </div>
                    }

                    @if (hasAtLeastOnePaymentSource) {
                        <h5 class="pb-3" i18n="@@CommonPaymentPageSelectPaymentMethod">
                            Select a Payment Method
                        </h5>
                        <lib-expansion-card-group>
                            @if (mode === PaymentSourceMode.Payment) {
                                <lib-expansion-card
                                    [startExpanded]="true"
                                    qaTag="$$PaymentPage_Card_ExistingPaymentMethod"
                                    (panelStatus)="ExistingPaymentMethodOpened($event)">

                                    <ng-container header>
                                        <lib-icon-bullet [icon]="Icon.Payment.CreditCard" [size]="IconSize.ExtraSmall">
                                            <p class="typography-caption-large typography-semibold" i18n="@@CommonPaymentPageUseExistingPaymentMethod">
                                                Use Existing Payment Method
                                            </p>
                                        </lib-icon-bullet>
                                    </ng-container>

                                    <ng-container body>
                                        <lib-payment-sources></lib-payment-sources>
                                        @if (isMobileOrTablet) {
                                            <ng-container *ngTemplateOutlet="paymentSummary; context: {$implicit: false}"></ng-container>
                                        } @else {
                                            <hr>
                                        }
                                        <div [ngClass]="{'d-flex justify-content-end': !isMobileOrTablet }" class="pt-3">
                                            <lib-button
                                                [disabled]="!amountToPay || !paymentProcessorReady || !surchargeReady"
                                                [toolTipText]="(amountToPay === null || amountToPay <= 0) ? 'Please enter a valid amount' : ''"
                                                [loading]="processing"
                                                [stretch]="isMobileOrTablet"
                                                (clicked)="PayUsingExistingPaymentMethod()"
                                                qaTag="$$PaymentPage_ExistingPaymentMethod_Button_PayNow">
                                                <ng-container label i18n="@@CommonPaymentPagePayNow">Pay Now</ng-container>
                                            </lib-button>
                                        </div>
                                    </ng-container>
                                </lib-expansion-card>
                            }
                            <lib-expansion-card
                                qaTag="$$PaymentPage_Card_NewPaymentMethod"
                                (panelStatus)="NewPaymentMethodOpened($event)">
                                    <ng-container header>
                                        <lib-icon-bullet [icon]="Icon.Payment.CreditCard" [size]="IconSize.Small">
                                            <p class="typography-caption-large typography-semibold" i18n="@@CommonPaymentPageNewPaymentMethod">
                                                New Payment Method
                                            </p>
                                        </lib-icon-bullet>
                                    </ng-container>
                                    <ng-container body>
                                        <ng-template *ngTemplateOutlet="addOrUseNewPaymentMethods"></ng-template>
                                    </ng-container>
                            </lib-expansion-card>
                        </lib-expansion-card-group>
                    } @else {
                        <h5 class="pb-3" i18n="@@CommonPaymentPagePaymentMethod">
                            Payment Method
                        </h5>
                        <lib-card qaTag="$$PaymentPage_Card_NoPaymentSource_PaymentMethod">
                            <ng-template *ngTemplateOutlet="addOrUseNewPaymentMethods"></ng-template>
                        </lib-card>
                    }
                </div>

                @if (!isMobileOrTablet) {
                    <div [ngClass]="{'w-25': !isMobileOrTablet, 'w-100': isMobileOrTablet, 'scss-summary-card-padding': context === PaymentContext.StudentPortal && !Scope.schoolInfo.AllowPartialPayments && !hasZeroAmountDue}" class="scss-sticky-summary-card">
                        <lib-card qaTag="$$PaymentPage_Card_Summary">
                            <ng-container *ngTemplateOutlet="paymentSummary; context: {$implicit: true}"></ng-container>
                        </lib-card>
                    </div>
                }
            </div>
        } @else if (currentStep === 1) {
            <lib-card qaTag="$$PaymentPage_Card_PaymentCompleted">
                <h5 i18n="@@CommonPaymentPagePaymentCompletedLabel">Payment Completed</h5>
                <p class="pt-3" i18n="@@CommonPaymentPagePaymentCompletedDescription">Your payment was completed successfully. It may take a few minutes before this payment is reflected on your account.</p>
                <div class="d-flex justify-content-center w-100 py-3">
                    @if(context !== PaymentContext.PaymentPortal){
                        <img src="assets/images/Payment Successful.svg">
                    }
                    @if(context === PaymentContext.PaymentPortal){
                        <lib-svg src="assets/images/InvoicePaid.svg" [height]="215"></lib-svg>
                    }
                </div>
                <hr>

                @if (paymentCompleteDisplayItem || processPaymentSourceResultItem) {
                    <p class="typography-semibold pb-4 pt-2" i18n="@@CommonPaymentPageTransactionDetailsLabel">Transaction Details</p>
                }
                @if (paymentCompleteDisplayItem) {
                    <div>
                        <p class="typography-semibold" i18n="@@CommonPaymentPageDateLabel">Date:</p>
                        <p class="pb-3" data-clarity-mask="true" [attr.data-sb-qa]="'$$PaymentPage_Text_PaymentCompleted_Date'">{{paymentCompleteDisplayItem.PaymentProcessorTimestamp | formatDate: 'long'}} {{paymentCompleteDisplayItem.PaymentProcessorTimestamp | formatTime: 'long'}}</p>
                    </div>
                    <div>
                        <p class="typography-semibold" i18n="@@CommonPaymentPagePaymentLabel">Payment:</p>
                        <p class="pb-3" data-clarity-mask="true" [attr.data-sb-qa]="'$$PaymentPage_Text_PaymentCompleted_Amount'">{{paymentCompleteDisplayItem.Amount | formatCurrency}}</p>
                    </div>
                    <div>
                        <p class="typography-semibold" i18n="@@CommonPaymentPageTransactionIDLabel">Transaction ID:</p>
                        <p class="pb-3" data-clarity-mask="true" [attr.data-sb-qa]="'$$PaymentPage_Text_PaymentCompleted_TransactionId'">{{paymentCompleteDisplayItem.PaymentProcessorTransactionID}}</p>
                    </div>
                }
                @if (processPaymentSourceResultItem) {
                    <div>
                        <p class="typography-semibold" i18n="@@CommonPaymentPageDateLabel">Date:</p>
                        <p class="pb-3" data-clarity-mask="true" [attr.data-sb-qa]="'$$PaymentPage_Text_PaymentProcessed_Date'">{{processPaymentSourceResultItem.TransactionTime! | formatDate: 'long'}} {{processPaymentSourceResultItem.TransactionTime! | formatTime: 'long'}}</p>
                    </div>
                    <div>
                        <p class="typography-semibold" i18n="@@CommonPaymentPagePaymentLabel">Payment:</p>
                        <p class="pb-3" data-clarity-mask="true" [attr.data-sb-qa]="'$$PaymentPage_Text_PaymentProcessed_Amount'">{{totalAmountToPay! | formatCurrency}}</p>
                    </div>
                    <div>
                        <p class="typography-semibold" i18n="@@CommonPaymentPageTransactionIDLabel">Transaction ID:</p>
                        <p class="pb-3" data-clarity-mask="true" [attr.data-sb-qa]="'$$PaymentPage_Text_PaymentProcessed_TransactionId'">{{processPaymentSourceResultItem.ProcessorTransactionID}}</p>
                    </div>
                }

                @if (context === PaymentContext.StudentPortal) {
                    <div class="d-flex justify-content-end">
                        <hr>
                        <lib-button
                            (clicked)="DoneClicked()"
                            [qaTag]="'done-btn'">
                            <ng-container label i18n="@@CommonDone">Done</ng-container>
                        </lib-button>
                    </div>
                }
            </lib-card>
        }
    </div>
}

<ng-template #schoolInformation>
    <div class="d-flex gap-3 flex-row flex-wrap">
        <img id="image-resize" imageResizer [src]="Scope.schoolInfo.InvoiceLogoURL">
        <div class="col-sm-3" data-clarity-mask="true">
            <lib-label>
                {{Scope.schoolInfo.Name}}
            </lib-label>
            @if (Scope.schoolInfo.Address) {
                <p class="typography-caption-large text-wrap-pre"
                    [textContent]="Scope.schoolInfo.Address">
                </p>
            }
        </div>
    </div>
    <hr>

    <div class="d-flex gap-1">
        <p class="typography-body-medium-strong" i18n="@@CommonAccountLabelWithColon">Account:</p>
        <p class="typography-body-medium" data-clarity-mask="true">{{Scope.paymentDetails.FamilyName}}</p>
    </div>
</ng-template>

<ng-template #paymentSummary let-showHeader>
    @if (showHeader) {
        <h5 class="text-nowrap" i18n="@@CommonPaymentPagePaymentSummary">Payment Summary</h5>
    }
    <hr>
    <div class="d-flex justify-content-between" [attr.data-sb-qa]="'$$PaymentPage_Row_Subtotal'">
        <p i18n="@@CommonSubtotalHeader">Subtotal</p>
        @if (amountToPay !== null) {
            <p>{{amountToPay | formatCurrency }}</p>
        }
        @if (amountToPay === null) {
            <!-- eslint-disable-next-line -->
            <p>---</p>
        }
    </div>
    @if (latePaymentFee) {
        <div class="d-flex justify-content-between" [attr.data-sb-qa]="'late-payment-fee'">
            <p i18n="@@CommonLatePaymentFeeHeader">Late Payment Fee</p>
            <p>{{latePaymentFee | formatCurrency}}</p>
        </div>
    }
    @if (schoolHasSurcharge) {
        <div class="d-flex justify-content-between" [attr.data-sb-qa]="'online-convenience-fee'">
            <p i18n="@@CommonOnlineConvenienceFeeHeader">Online Convenience Fee</p>
            @if (surcharge !== null) {
                <p>{{surcharge | formatCurrency}}</p>
            }
            @if (surcharge === null) {
                <!-- eslint-disable-next-line -->
                <p>---</p>
            }
        </div>
    }
    <hr>
    <div class="d-flex justify-content-between" [attr.data-sb-qa]="'$$PaymentPage_Row_TotalAmount'">
        <p class="typography-semibold" i18n="@@CommonTotalHeader">Total</p>
        @if (totalAmountToPay !== null) {
            <p class="typography-semibold">{{totalAmountToPay | formatCurrency}}</p>
        }
        @if (totalAmountToPay === null && !surcharge && latePaymentFee === null) {
            <!-- eslint-disable-next-line -->
            <p class="typography-semibold">---</p>
        }
        @if (totalAmountToPay === null && !surcharge && latePaymentFee !== null) {
            <p class="typography-semibold">{{latePaymentFee | formatCurrency}}</p>
        }
    </div>
</ng-template>

<ng-template #addOrUseNewPaymentMethods>
    <lib-add-payment-source></lib-add-payment-source>

    @if (isMobileOrTablet) {
        <ng-container *ngTemplateOutlet="paymentSummary; context: {$implicit: false}"></ng-container>
    }
    @if (Scope.paymentProcessor!.StoredPaymentMethodsSupported) {
        @if (!isMobileOrTablet) {
            <hr>
        }
        <div [ngClass]="{'d-flex justify-content-end': !isMobileOrTablet }" class="pt-3">
            <lib-button
                [disabled]="(Scope.paymentProcessor!.Type === PaymentProcessorType.PayPalPro) || !amountToPay || !paymentProcessorReady || !surchargeReady"
                [toolTipText]="!amountToPay ? 'Please enter a valid amount' : ''"
                [loading]="processing"
                [stretch]="isMobileOrTablet"
                (clicked)="PayUsingNewPaymentMethod()"
                qaTag="$$PaymentPage_NewPaymentMethod_Button_PayNow">
                <ng-container label i18n="@@CommonPaymentPagePayNow">Pay Now</ng-container>
            </lib-button>
        </div>
    }
</ng-template>